import { useEffect, useState } from "react";
import api from "@/lib/api";
import { timeAgo } from "@/lib/format";

export function CompletedUndertakings({ userId }) {
  const [items, setItems] = useState(null);
  useEffect(() => {
    api.get(`/users/${userId}/undertakings/completed`).then(({ data }) => setItems(data)).catch(() => setItems([]));
  }, [userId]);

  return (
    <div data-testid="completed-undertakings">
      <label className="text-xs uppercase tracking-widest" style={{ color: "var(--text-muted)" }}>completed undertakings</label>
      {!items ? (
        <p className="text-sm mt-3" style={{ color: "var(--text-muted)" }}>Loading…</p>
      ) : items.length === 0 ? (
        <p className="text-sm mt-3" style={{ color: "var(--text-muted)" }} data-testid="completed-undertakings-empty">none yet.</p>
      ) : (
        <ul className="flex flex-col gap-3 mt-3" data-testid="completed-undertakings-list">
          {items.map((u) => (
            <li key={u.id} data-testid={`completed-undertaking-${u.id}`} className="px-4 py-3" style={{ border: "1px solid var(--border)" }}>
              <div className="flex items-center gap-3 mb-2">
                <span className="text-[10px] uppercase tracking-widest px-2 py-1" style={{ border: "1px solid var(--border)", color: "var(--accent)" }}>{u.subject}</span>
                <span className="text-xs ml-auto shrink-0" style={{ color: "var(--accent)" }}>{u.provisions} provisions</span>
              </div>
              <p className="long-text-sm text-sm" style={{ color: "var(--text-secondary)" }}>{u.text}</p>
              <p className="text-xs mt-2" style={{ color: "var(--text-muted)" }}>delegated by {u.author?.name || "unknown"} · {timeAgo(u.completed_at)}</p>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
